var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showIf)?_c('b-button',{staticClass:"mb-2",staticStyle:{"width":"10em"},attrs:{"variant":"primary","disabled":_vm.disabled},on:{"click":_vm.confirmPress}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }